import {Avatar, Box, Button, Card, IconButton, Typography, alpha, css, styled} from '@mui/material';
import {StyledCardProps, StylesButtonProps} from './types';

const StyledCard = styled(Card)<StyledCardProps>`
	justify-content: space-between;
	border: 1px solid transparent;
	flex-direction: row;
	align-items: center;
	cursor: pointer;
	padding: 16px;
	display: flex;
	gap: 8px;
	flex: 1;

	${({selected, theme}) =>
		selected &&
		css`
			border-color: ${theme.palette.success.main};
		`}
`;

const StyledTypography = styled(Typography)`
	text-overflow: ellipsis;
	max-height: 40px;
	overflow: hidden;
`;

const StyledButton = styled(Button)<StylesButtonProps>`
	min-width: fit-content;
	border-radius: 4px;
	${({$selected, theme}) =>
		$selected &&
		css`
			background-color: ${theme.palette.success.shades['12p']};
		`}
`;

const IconContainer = styled(Box)`
	background-color: ${({theme}) => alpha(theme.palette.primary.main, 0.12)};
	color: ${({theme}) => theme.palette.primary.main};
	border-radius: 20px;
	display: flex;
	padding: 8px;
`;

const StyledIconButton = styled(IconButton)`
	padding: 4px;
`;

const ProfileIcon = styled(Avatar)<{$blocked?: boolean}>`
	background-color: ${({theme, $blocked}) =>
		$blocked
			? theme.palette.action.disabledBackground
			: theme.colors.light.primary['170Percent']};
	width: 42px;
	height: 42px;
	align-self: baseline;
`;

export {ProfileIcon, StyledCard, StyledTypography, StyledButton, IconContainer, StyledIconButton};
